import { observable, runInAction } from "mobx"

import { Paginator } from "~/@shared/api-types/Paginator"
import { fetchGetNewGradJobsById, NewGradJobDetail } from "~/api/new-grad-jobs/[id]/get"
import { NewGradJob as NewGradJobJson } from "~/api/new-grad-jobs/_types"
import { fetchGetNewGradJobs } from "~/api/new-grad-jobs/get"
import { fetchGetNewGradJobsGrouped } from "~/api/new-grad-jobs/grouped/get"
import { fetchGetNewGradJobsLimited } from "~/api/new-grad-jobs/limited/get"
import { fetchGetNewGradJobsPickup } from "~/api/new-grad-jobs/pickup/get"
import { NewGradJob, GroupedRecruitment } from "~/entities/NewGradJob"
import { PageInfo } from "~/entities/PageInfo"

export default class NewGradJobStore {
  @observable newGradJob: NewGradJob | null = null
  @observable newGradJobs: Array<NewGradJob> = []
  @observable newGradJobsGroupedByOccupation: Array<GroupedRecruitment> = []
  @observable recommendedNewGradJobs?: Paginator<NewGradJobJson> | undefined
  @observable pageInfo: PageInfo | null = null

  fetchByLimited = async (number?: number): Promise<NewGradJob[]> => {
    const res = await fetchGetNewGradJobsLimited({ count: number })
    const data = (res.data || []).map((datum) => {
      return new NewGradJob(datum as any)
    })
    runInAction(() => {
      this.newGradJobs = data
    })
    return number === undefined ? this.newGradJobs : this.newGradJobs.slice(0, number)
  }

  // status = draft のときは limitedUrlToken が正しくないと404が返される
  fetchById = async (id: number, limitedUrlToken?: string | string[]): Promise<NewGradJobDetail | null> => {
    const res = await fetchGetNewGradJobsById({ id, limitedUrlToken })

    // if ( res.errorCode > 200) {
    if ("errorCode" in res) {
      return null
    }
    return res
  }

  fetchGroupedRecruitment = async () => {
    const res = await fetchGetNewGradJobsGrouped()

    runInAction(() => {
      this.newGradJobsGroupedByOccupation = res
    })
    return this.newGradJobsGroupedByOccupation
  }

  fetchPickupRecruitment = async (page?: number) => {
    const res = await fetchGetNewGradJobsPickup({ page })

    runInAction(() => {
      this.recommendedNewGradJobs = res
    })
    return this.recommendedNewGradJobs
  }
}
